import React, {useState} from "react";
import {Form, Input, Modal} from "antd";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {TICKET_MAX_NOTE_LENGTH} from "constants/ticket";

export const CancelTicketModal = ({ticket, visible, onCancel, onCancelled}) => {
    const {t} = useTranslation(["tickets"]);
    const stores = useStore();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        let values;
        try {
            values = await form.validateFields();
        } catch (error) {
            return;
        }
        setLoading(true);
        const result = await stores.ticketStore.cancelTicket(ticket._id, {
            note: values.note.trim()
        });
        setLoading(false);
        if (result) {
            form.resetFields();
            onCancelled();
        }
    };

    return (
        <Modal
            title={t("detail.cancelModal.title", {ns: "tickets"})}
            visible={visible}
            onOk={handleSubmit}
            onCancel={onCancel}
            confirmLoading={loading}
            okText={t("detail.cancelModal.confirm", {ns: "tickets"})}
            okButtonProps={{danger: true}}
            cancelText={t("detail.cancelModal.cancel", {ns: "tickets"})}
            destroyOnClose
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label={t("detail.cancelModal.note", {ns: "tickets"})}
                    name="note"
                    extra={t("detail.cancelModal.ownerVisibleHint", {ns: "tickets"})}
                    rules={[
                        {
                            required: true,
                            whitespace: true,
                            message: t("detail.cancelModal.noteRequired", {ns: "tickets"})
                        }
                    ]}
                    style={{marginBottom: 0}}
                >
                    <Input.TextArea
                        rows={4}
                        maxLength={TICKET_MAX_NOTE_LENGTH}
                        placeholder={t("detail.cancelModal.notePlaceholder", {ns: "tickets"})}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};
